
export default (state = '', action) => {
    if (action.type === 'GENERATE_UNIQUE_ID') {
        return action.payload;
    }

    return state;
}